import '@leenguyen/react-flip-clock-countdown/dist/index.css';
import FlipClockCountdown from '@leenguyen/react-flip-clock-countdown';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { frostedPillCss } from 'src/common/styles/frostedPanelStyles';
import { Dayjs } from 'src/helpers/dayjs';
import { useTranslation } from 'react-i18next';

import { ICountdownBlock } from 'src/interfaces/PageBlock';

interface Props {
  block: ICountdownBlock;
  eventDate: Dayjs;
}

export default function CountdownBlockContent({ block, eventDate }: Props) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const renderMap = block.renderMap ?? [true, true, false, false];

  const digitW = isSmall ? 30 : 40;
  const digitH = isSmall ? 42 : 55;

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        overflowX: { xs: 'auto', sm: 'visible' },
        overflowY: 'visible',
        pb: 2.5,
        '& > div': {
          // Library reserves margin-bottom as 2× this value for labels below digits.
          '--fcc-label-font-size': '22px',
        },
      }}
    >
      <FlipClockCountdown
        to={eventDate.toDate()}
        labelStyle={{
          fontSize: '.8em',
          color: theme.palette.text.primary,
          fontFamily: ['JetBrains Mono', 'monospace'].join(','),
          textTransform: 'uppercase',
          ...frostedPillCss(theme),
          boxShadow: '0 6px 16px rgba(0, 0, 0, 0.35)',
        }}
        renderMap={renderMap}
        labels={[
          t('timers.flipClockLabels.days'),
          t('timers.flipClockLabels.hours'),
          t('timers.flipClockLabels.minutes'),
          t('timers.flipClockLabels.seconds'),
        ]}
        digitBlockStyle={{
          fontSize: isSmall ? '0.85em' : '1em',
          width: `${digitW}px`,
          height: `${digitH}px`,
          boxShadow: '0 12px 24px rgba(0, 0, 0, 0.3)',
        }}
      />
    </Box>
  );
}
